import client from './client'
import type {
  CreditBalance,
  CreditLedgerEntry,
  CreditPurchaseIntent,
} from '@/types/newsletter'
import type { PaginatedResponse } from '@/types/finance'

function base(organisationId: number): string {
  return `/organizer/organisations/${organisationId}/credits`
}

export async function fetchCreditBalance(organisationId: number): Promise<CreditBalance> {
  const { data } = await client.get<{ data: CreditBalance }>(`${base(organisationId)}/balance`)
  return data.data
}

export async function fetchCreditLedger(
  organisationId: number,
  params: { type?: string; page?: number; per_page?: number } = {},
): Promise<PaginatedResponse<CreditLedgerEntry>> {
  const { data } = await client.get<{
    data: CreditLedgerEntry[]
    meta: PaginatedResponse<CreditLedgerEntry>['meta']
  }>(`${base(organisationId)}/ledger`, { params })
  return { data: data.data, meta: data.meta }
}

export async function createCreditPurchase(
  organisationId: number,
  quantity: number,
): Promise<CreditPurchaseIntent> {
  const { data } = await client.post<CreditPurchaseIntent>(`${base(organisationId)}/purchase`, {
    quantity,
  })
  return data
}
